/**
 * Authoring caps (design D11).
 *
 * These keep exhaustive solving tractable, and they are validation errors
 * rather than guidelines. `level.schema.json` enforces the structural half of
 * each — a `maximum` on `objectives.phaseBudget`, on `proposal.maxHops`, on
 * `slots[].optionCap`, on `objectives.maxTargetsPerPhase`, and a `maxItems` on
 * `slots`. The dynamic half — how many options a slot actually offers at a
 * given point in a mission, and how deep a chain of `propagate` steps can
 * reach — is not expressible in JSON Schema and is checked by the validator's
 * referential pass against these same numbers.
 *
 * `caps.test.ts` asserts the two stay in step.
 */
export const CAPS = {
    /** Selectable options per slot, at any point in a mission. */
    slotOptions: 8,
    /** Addressable send targets per phase. */
    targetsPerPhase: 6,
    /** Phases a mission may declare before profile scaling. */
    phaseBudget: 20,
    /** Hops a proposal may travel before the chain terminates. */
    propagationHops: 4,
    /** Slots the composer renders at once, mission slots plus persona slots. */
    activeSlots: 5,
};
//# sourceMappingURL=caps.js.map